import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [설정 > 사용자관리] 사용자 접근이력에서 사용자 로그인/로그아웃 이력을 조회
   * @author Song
   * @param  {[type]} params startDatetime, endDatetiem
   * @return {[type]}
   */
  getUserLoginHist(params) {
    return axios.post(`${baseUrl}/settings/user/access/get-user-login-hist.do`, params);
  },
  /**
   * [설정 > 사용자관리] 사용자 접근이력 - 사용자 접속 차트 데이터 조회
   * @author Song
   * @param  {[type]} params startDatetime, endDatetiem
   * @return {[type]}
   */
  getUserLoginChartData(params) {
    return axios.post(`${baseUrl}/settings/user/access/get-user-login-chart-data.do`, params);
  },
  /**
   * [설정 > 사용자관리] 사용자 접근이력 -기간 내 장비 수행 이력 테이블을 조회한다.
   * @author Song
   * @param  {[type]} params startDatetime, endDatetiem
   * @return {[type]}
   */
  getMgrObjActionHist(params) {
    return axios.post(`${baseUrl}/settings/user/access/get-mgr-obj-action-hist.do`, params);
  },
  /**
   * [설정 > 사용자관리] 사용자 접근이력 - 기간 내 설정 변경 이력 테이블 조회한다.
   * @author Song
   * @param  {[type]} params startDatetime, endDatetiem
   * @return {[type]}
   */
  getMgrSettingChngHist(params) {
    return axios.post(`${baseUrl}/settings/user/access/get-mgr-setting-chng-hist.do`, params);
  },
  /**
   * [설정 > 사용자관리] 사용자 접근이력 - 기간 내 최다 접속 대상을 조회한다.
   * @author Song
   * @param  {[type]} params startDatetime, endDatetiem
   * @return {[type]}
   */
  getMostLoginUserCount(params) {
    return axios.post(`${baseUrl}/settings/user/access/get-most-login-user-count.do`, params);
  },
  /**
   * [설정 > 사용자관리] 사용자 접근이력 - 기간 내 최장 세션 유지 대상을 조회한다.
   * @author Song
   * @param  {[type]} params startDatetime, endDatetiem
   * @return {[type]}
   */
  getLongestSessionConnect(params) {
    return axios.post(`${baseUrl}/settings/user/access/get-longest-session-connect.do`, params);
  },
  /**
   * [설정 > 사용자/권한 관리 > 사용자 접근 이력] 엑셀 출력
   * 4개탭(로그인/로그아웃 이력_export-user-access-hist.do, 메뉴 접근 이력_export-menu-access-hist.do,
   * 장비수행 이력_export-obj-action-hist.do, 설정변경 이력_export-setting-change-hist.do) 공통
   */
  exportHist(params, key) {
    return axios.post(`${baseUrl}/settings/user/access/export-${key}-hist.do`, params);
  },
  getMenuAccessHistList(params) {
    return axios.post(`${baseUrl}/settings/user/access/get-menu-access-hist-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/user/user-access-hist.js